import React from "react";
import { NavLink } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { useTranslation, Trans } from 'react-i18next';

import api from './../../../api';

import { firstError } from './../../../utils/errors';

import PasswordRecoveryForm from './PasswordRecoveryForm';

function PasswordRecoveryContainer() {

    const { t } = useTranslation();
    const [ statusAlert, setStatusAlert ] = React.useState(null);
    const [ submitting, setSubmitting ] = React.useState(false);

    const _handlePasswordRecovery = values => {

        setSubmitting(true);
        setStatusAlert(null);

        api.auth.resetPassword(values).then(response => {
            if(!response || !response.data || !response.data.data || !response.data.data.message) {
                throw new Error('request failed');
            }
        setStatusAlert({type: 'success', message: <Trans i18nKey="auth.passwordResetSuccess" values={values}></Trans>})
        }).catch(response => {
            const error = firstError(response);
            if(error && error.code === 1010) {
                setStatusAlert({type: 'danger', message: <Trans i18nKey="auth.failedToResetPasswordCheckEmail" values={values}></Trans>})
            } else {
                setStatusAlert({type: 'danger', message: t('auth.failedToResetPassword')})
            }
        }).finally(() => {
            setSubmitting(false);
        })
    }

	return (
		<React.Fragment>
			<h1 style={{marginBottom: '10px' }}>{t('auth.forgotYourPasswordTitle')}</h1>
			<p className="text-muted">{t('auth.forgotYourPasswordSubtitle')}.</p>

			<hr />

            {statusAlert ?
                <Alert variant={statusAlert.type}>
                    {statusAlert.message}
                </Alert>
            : null}

            <PasswordRecoveryForm
                onSubmit={_handlePasswordRecovery}
                submitting={submitting}
            />

			<hr />

			<NavLink to={`/`}>{t('auth.backToLogin')}</NavLink>
		</React.Fragment>
	);
}

export default PasswordRecoveryContainer;
